import { reviewsConstants } from '@constants/reviews';

const isVersionOf = (review, other) =>
    !!other.id &&
    review.id === other.id &&
    review.locationId === other.locationId &&
    review.integrationName === other.integrationName;

const initialState = {
    loading: true,
    newReviewsExist: false,
    reviews: [],
    pageToken: null,
};

export function reviews(state = initialState, action) {
    switch (action.type) {
        case reviewsConstants.REVIEWS_REQUEST:
            return { ...state, loading: true };
        case reviewsConstants.REVIEWS_SUCCESS:
            return {
                ...state,
                reviews: action.payload.items,
                pageToken: action.payload.nextPageToken,
                loading: false,
            };
        case reviewsConstants.REVIEWS_LOAD_MORE_SUCCESS:
            return {
                ...state,
                reviews: [...state.reviews, ...action.payload.items],
                pageToken: action.payload.nextPageToken,
            };
        case reviewsConstants.NEW_REVIEW_EXIST_SUCCESS:
            return { ...state, newReviewsExist: action.payload };
        case reviewsConstants.NEW_REVIEW_EXIST_RESET:
            return { ...state, newReviewsExist: false };
        case reviewsConstants.UPDATE_REVIEWS:
            return { ...state, reviews: action.payload };
        case reviewsConstants.UPDATE_REVIEW:
            return {
                ...state,
                reviews: state.reviews.map(review => {
                    if (review.reviewId === action.payload.reviewId) return action.payload;
                    return isVersionOf(review, action.payload)
                        ? { ...review, isDeleted: action.payload.isDeleted }
                        : review;
                }),
            };
        case reviewsConstants.RESET_LOADING:
            return { ...state, loading: false };
        default:
            return state;
    }
}
